import React from "react";
import { WHY_LOVE } from "@/data/catalog";
import { DynIcon } from "@/components/DynIcon";
import { SectionHeading } from "@/components/home/SectionHeading";

export const WhyLove = () => (
  <section className="bg-[#F8F5EF] py-16 md:py-24" data-testid="why-love">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading overline="Why parents love it" title="Care that feels gentle and simple" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {WHY_LOVE.map((item) => (
          <div
            key={item.title}
            data-testid={`why-card-${item.title}`}
            className="bg-white rounded-3xl p-8 shadow-[0_4px_24px_rgba(111,80,58,0.05)]"
          >
            <div className="w-12 h-12 rounded-2xl bg-[#B8C4A3]/20 flex items-center justify-center mb-5">
              <DynIcon name={item.icon} className="w-6 h-6 text-[#6F503A]" />
            </div>
            <h3 className="font-heading text-lg font-semibold text-[#6F503A] mb-2">{item.title}</h3>
            <p className="text-sm text-[#6F503A]/70 leading-relaxed">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
